<style lang="scss" scoped>
label {
  font-weight: normal;
}
p {
  background-color: whitesmoke;
  border-radius: 2px;
  margin: 2px;
  padding: 5px;
}
small {
  font-size: 0.7rem;
  font-style: italic;
}
</style>
<template lang="pug">
.frow.row-start.mb-25
  .field(v-if="printOut")
    strong {{ question }}
    p {{ value }}
  .field(v-else)
    label.label.reset {{ question }}
    small(v-if="example") e.g. {{ example }}
    p.control
      input(
        :name="name",
        :value="value"
        type="text",
        @input="$emit('input', $event.target.value)"
      )
</template>
<script>
export default {
  name: "text-input",
  props: {
    example: {
      type: String,
      default: "Title"
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    printOut: {
      type: Boolean,
      default: false
    },
    question: {
      type: String,
      default: "Title"
    },
    value: {
      type: String
    }
  }
};
</script>
